import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body px-10 px-lg-20 pb-10" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_3 = { class: "d-flex flex-row mt-10 gap-5" }
const _hoisted_4 = { class: "col-lg-7 mb-10 mb-lg-0" }
const _hoisted_5 = { class: "nav flex-column" }
const _hoisted_6 = ["onClick", "data-bs-target"]
const _hoisted_7 = { class: "d-flex align-items-center me-2" }
const _hoisted_8 = { class: "form-check form-check-custom form-check-solid form-check-success me-6" }
const _hoisted_9 = ["value", "checked"]
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "d-flex align-items-center fs-2 fw-bold flex-wrap" }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-light-success ms-2 fs-7"
}
const _hoisted_13 = { class: "fw-semobold opacity-50" }
const _hoisted_14 = { class: "ms-5" }
const _hoisted_15 = {
  key: 0,
  class: "btn btn-sm btn-primary"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "$", -1)
const _hoisted_17 = { class: "fs-3x fw-bold" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 opacity-50" }, [
  /*#__PURE__*/_createTextVNode("/ "),
  /*#__PURE__*/_createElementVNode("span", { "data-kt-element": "period" }, "Mon")
], -1)
const _hoisted_19 = { class: "col-lg-5" }
const _hoisted_20 = { class: "tab-content rounded h-100 bg-light p-10" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "pb-5" }
const _hoisted_23 = { class: "fw-bold text-dark" }
const _hoisted_24 = { class: "text-gray-400 fw-semibold" }
const _hoisted_25 = { class: "d-flex flex-column text-center justify-content-center fs-2x mt-5" }
const _hoisted_26 = { class: "text-danger fw-bold" }
const _hoisted_27 = { class: "pt-1" }
const _hoisted_28 = { class: "fw-semobold fs-5 text-gray-700 flex-grow-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success fs-1" }, null, -1)
const _hoisted_30 = { class: "fw-semobold fs-5 text-gray-400 flex-grow-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill text-secondary fs-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadTable)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 0,
          rows: 5,
          animated: ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPlans, (plan, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (_ctx.handleSelected(plan.code)),
                    class: _normalizeClass(["nav-link btn btn-outline btn-outline-dashed btn-color-dark d-flex flex-stack text-start p-6", [
                    index !== _ctx.sortedPlans.length - 1 && 'mb-6',
                    plan.is_default == 'yes' && 'active',
                    plan.is_custom !== 'yes' && 'btn-active btn-active-primary',
                  ]]),
                    "data-bs-toggle": "tab",
                    "data-bs-target": `#kt_upgrade_plan_${index}`
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "plan",
                          value: plan.code,
                          checked: 
                          _ctx.selected === plan.code || plan.is_default === 'yes'
                        
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h2", _hoisted_11, [
                          _createTextVNode(_toDisplayString(plan.name) + " ", 1),
                          (plan.label)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(plan.label), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(plan.subtitle), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (plan.is_custom === 'yes')
                        ? (_openBlock(), _createElementBlock("button", _hoisted_15, " Contact Us "))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.current === 'month'
                            ? _ctx.formatMoney(plan.monthly_price)
                            : plan.annual_price), 1),
                            _hoisted_18
                          ], 64))
                    ])
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPlans, (plan, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (plan.is_custom !== 'yes')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([[
                    (plan.is_default == 'yes' || plan.code == _ctx.selected) &&
                      'show active',
                  ], "tab-pane fade"]),
                          id: `kt_upgrade_plan_${index}`
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("h2", _hoisted_23, " What’s in " + _toDisplayString(plan.name) + "? ", 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(plan.description), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(plan.quantity > 0 ? plan.quantity : 'No') + " " + _toDisplayString(plan.quantity > 1 ? 'Entries' : 'Entry'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (feature, i) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                (plan.features)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass([{
                            'mb-7': i !== plan.features.length - 1,
                          }, "d-flex align-items-center"])
                                    }, [
                                      (feature.supported === 'yes')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", _hoisted_28, _toDisplayString(feature.title), 1),
                                            _hoisted_29
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("span", _hoisted_30, _toDisplayString(feature.title), 1),
                                            _hoisted_31
                                          ], 64))
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ], 10, _hoisted_21))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ]))
  ]))
}